module.exports = __webpack_public_path__ + "img/lands-square.ccda49d3.svg";